var exports = {
  "g4": "AuthPageStyles.module__loadingContainer___ZS1iUm",
  "Un": "AuthPageStyles.module__errorContainer___ZS1iUm",
  "ik": "AuthPageStyles.module__errorIcon___ZS1iUm",
  "gi": "AuthPageStyles.module__errorIconSvg___ZS1iUm",
  "JU": "AuthPageStyles.module__errorTitle___ZS1iUm",
  "kc": "AuthPageStyles.module__errorText___ZS1iUm",
  "kL": "AuthPageStyles.module__container___ZS1iUm",
  "TQ": "AuthPageStyles.module__entityHeader___ZS1iUm",
  "Ep": "AuthPageStyles.module__entityDetails___ZS1iUm",
  "Pp": "AuthPageStyles.module__entityText___ZS1iUm",
  "j2": "AuthPageStyles.module__entityTitleWrapper___ZS1iUm",
  "wD": "AuthPageStyles.module__entityTitle___ZS1iUm",
  "N2": "AuthPageStyles.module__entityStats___ZS1iUm",
  "So": "AuthPageStyles.module__entityStat___ZS1iUm",
  "RS": "AuthPageStyles.module__onlineDot___ZS1iUm",
  "FD": "AuthPageStyles.module__offlineDot___ZS1iUm",
  "KA": "AuthPageStyles.module__statText___ZS1iUm",
  "Wp": "AuthPageStyles.module__entityIconWrapper___ZS1iUm",
  "fq": "AuthPageStyles.module__entityIcon___ZS1iUm",
  "Ly": "AuthPageStyles.module__themeIconSpot___ZS1iUm",
  "J3": "AuthPageStyles.module__themeIcon___ZS1iUm",
  "Zd": "AuthPageStyles.module__form___ZS1iUm",
  "ee": "AuthPageStyles.module__registrationNotice___ZS1iUm",
  "Gr": "AuthPageStyles.module__bottomLink___ZS1iUm",
  "fH": "AuthPageStyles.module__bottomLinkText___ZS1iUm",
  "J5": "AuthPageStyles.module__bottomLinkAnchor___ZS1iUm",
  "cB": "AuthPageStyles.module__usernameHint___ZS1iUm",
  "Jy": "AuthPageStyles.module__suggestionLink___ZS1iUm",
  "LB": "AuthPageStyles.module__usernameError___ZS1iUm",
  "$M": "AuthPageStyles.module__consentRow___ZS1iUm",
  "t6": "AuthPageStyles.module__consentLabel___ZS1iUm",
  "Rf": "AuthPageStyles.module__policyLink___ZS1iUm",
  "ii": "AuthPageStyles.module__disabledContainer___ZS1iUm",
  "aV": "AuthPageStyles.module__disabledText___ZS1iUm",
  "ax": "AuthPageStyles.module__disabledSubtext___ZS1iUm",
  "SO": "AuthPageStyles.module__disabledActions___ZS1iUm",
  "ns": "AuthPageStyles.module__disabledActionLink___ZS1iUm",
  "DD": "AuthPageStyles.module__title___ZS1iUm",
  "Zo": "AuthPageStyles.module__giftIconContainer___ZS1iUm",
  "ez": "AuthPageStyles.module__giftIcon___ZS1iUm",
  "PM": "AuthPageStyles.module__entitySubtext___ZS1iUm",
  "W$": "AuthPageStyles.module__subtext___ZS1iUm",
};

module.exports = exports;
